import { copyFileUrlToClipboard } from "Source/components/project/Files/Helpers/Helpers";
import { createDocumentLog } from "Source/api/activityLog";
import { rename, favorite, read, removeRead, tagWorkstream, move, fetchDocuments } from "Source/api/files";
import {  getFileUrl, downloadDocumentInBrowser } from "Source/components/project/Files/Helpers/Helpers";

export const downloadDocument = (projectId, document, page) => {
    downloadDocumentInBrowser(document.name, document.origin)
    
    const documents = [document];
    const data =  documents.map(doc =>{ 
        return  {
            linkId: doc.documentId,
            linkType:'document',
            title: `download ${doc.type === 'folder'? 'the ': 'a'} ${doc.origin}`,
            actionType: 'download',
            old: '',
            new: doc.origin,
            projectId,
            activity: `Downloaded ${doc.type === 'folder'? 'the folder ': 'a file'} ${page? "from "+ page :""}`
        }
    })

    return createDocumentLog(data);
}

export const copyFileUrl = (projectId, documentId) => {
    const fileUrl = getFileUrl(projectId, documentId);
    const data = [{
        linkType: "document",
        linkId: documentId,
        actionType: "copy",
        title:'copied file URL of',
        projectId: projectId,
        activity:"Copied File URL"
    }];

    copyFileUrlToClipboard(fileUrl);

    return  createDocumentLog(data);
}

export const renameDocument = (renameParams, document) => {

    const params = {
        origin: renameParams.updatedName,
        oldDocument: document.origin,
        newDocument: renameParams.updatedName,
        usersId: renameParams.userId,
        projectId: renameParams.projectId,
        type: document.type,
        force: renameParams.force || 0,
        page: renameParams.page
    };

    return rename(params, document.documentId, renameParams.userId);
}

export const favoriteDocument = (favoriteParams) => {
    const { projectId, isStarred, linkId, linkType } =  favoriteParams;
   
    const params = {
        projectId,
        isDeleted: isStarred === true
            ? 1
            : 0,
        linkId,
        linkType,
    };

    
    return favorite(params);
}

export const readDocument = (readParams) => {
    let apiCall = null;
    const params = { 
        usersId: readParams.userId,
        documentId: readParams.documentId,
        source: readParams.source,
    };

    // Toggling behavior
    if (!readParams.isRead) {
        params.isDeleted = 0;
        apiCall = read(params);
    } else {
        apiCall = removeRead(params);
    }

    return apiCall;
}

export const tagWorkstreamToDocument = (tagParams) => {
    const params = {
        projectId: tagParams.projectId,
        data: tagParams.data
    };

    return tagWorkstream(params);
}

export const moveDocuments = (moveParams) => {
    const { documentIds, destination, projectId, userId, source } = moveParams;
    const params = {
        documentIds: documentIds,
        data: {
            folderId: destination.id,
            folder: destination.origin,
            projectId: projectId,
            usersId: userId,
            actionType: "moved",
            source,
        } 
    }
 
    return move(destination.id,  params);
}

export const fetchLibraryDocuments = (fetchParams) => {
    const { folderId, projectId, type } = fetchParams;

    const params = {
        projectId,
        ...(type && {type}),
        ...(folderId && {folderId}),
    }
 
    return fetchDocuments(params);
}

